import { useState } from 'react';
import { ShieldAlert, LogOut } from 'lucide-react';
import { api, type CurrentUser } from '../api/client';

// Bandeau de prise en main de compte.
//
// Il n'est pas décoratif. Sans lui, un exploitant venu dépanner une agence prend
// la vue de celle-ci pour la sienne : il modifie un dossier, corrige une
// configuration, supprime une ligne — chez quelqu'un d'autre, en croyant être
// chez lui. Le bandeau est donc permanent, en haut, et impossible à replier.
//
// Il rappelle aussi que la session expire d'elle-même : on dépanne, on ne
// s'installe pas.

export default function ImpersonationBanner({ user }: { user: CurrentUser | null }) {
  const [leaving, setLeaving] = useState(false);
  if (!user?.impersonatedBy) return null;

  return (
    <div className="sticky top-0 z-50 bg-amber-500 text-amber-950 px-4 py-2 flex flex-wrap items-center justify-between gap-2 shadow-md">
      <p className="text-xs font-black flex items-center gap-2">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <span>
          Prise en main du compte {user.email || user.displayName} — vos actions
          s'appliquent aux données de cette agence.
        </span>
      </p>
      <button
        onClick={async () => {
          setLeaving(true);
          try {
            await api.stopImpersonation();
          } finally {
            // Rechargement complet : tout ce qui est en mémoire a été chargé
            // sous l'identité de l'agence et n'a plus lieu d'être affiché.
            window.location.href = '/';
          }
        }}
        disabled={leaving}
        className="bg-amber-950 text-amber-50 font-bold text-[11px] uppercase tracking-wider px-3 py-1.5 rounded-lg cursor-pointer disabled:opacity-60 flex items-center gap-1.5 shrink-0"
      >
        <LogOut className="w-3.5 h-3.5" />
        {leaving ? 'Sortie…' : 'Quitter'}
      </button>
    </div>
  );
}
